import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Alert, Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import LockResetRoundedIcon from "@mui/icons-material/LockResetRounded";
import { api } from "../api/axios";
import { IconTile } from "../components/ui";
import { accentText, AuthShell, DirArrow } from "./marketing/MarketingParts";
import { EmailField } from "./marketing/AuthFields";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/api/users/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.message || t("mka_err"));
    }
  };

  return (
    <AuthShell
      title={t("mka_forgot_title")}
      subtitle={t("mka_forgot_sub")}
      icon={
        <IconTile size={48}>
          <LockResetRoundedIcon />
        </IconTile>
      }
      footer={
        <Box component={Link} to="/login" sx={{ color: accentText, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 0.5 }}>
          {t("mka_back_login")}
        </Box>
      }
    >
      <Box aria-live="polite">
        {done ? <Alert severity="success">{t("mka_forgot_done")}</Alert> : null}
      </Box>
      {!done ? (
        <Box component="form" onSubmit={onSubmit} sx={{ display: "grid", gap: 2 }}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <EmailField label={t("mka_email")} value={email} onChange={(e) => setEmail(e.target.value)} />
          <Button type="submit" variant="contained" size="large" fullWidth endIcon={<DirArrow />}>
            {t("mka_forgot_btn")}
          </Button>
        </Box>
      ) : null}
    </AuthShell>
  );
}
